<template>
  <div class="my-order" ref="container">
    <div class="header my-order-header">
      <div class="picTxt acea-row row-between-wrapper">
        <div class="text">
          <div class="name">我的订单信息</div>
        </div>
        <div class="pictrue"><img src="@assets/images/orderTime.png" /></div>
      </div>
    </div>
    <div class="list">
      <div class="item" v-for="order in orderList" :key="order.customerOrderId">
        <div class="title acea-row row-between-wrapper">
          <div class="font-color-red">物品：{{ order.orderItem.prodName }}</div>
        </div>
            <div class="text acea-row row-between">
              <div style="margin-left: 4vw">
                订单状态:{{ order.stsvalue }}
              </div>
                <div style="margin-right: 2vw">
                  兑换时间:{{ order.createDate |formatDateDay}}
                </div>
            </div>
          </div>
        </div>

    <div class="noCart" v-if="orderList.length === 0">
      <div class="pictrue"><img src="@assets/images/noOrder.png" /></div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
    <GeneralWindow
      :generalActive="generalActive"
      @closeGeneralWindow="closeGeneralWindow"
      :generalContent="generalContent"
    ></GeneralWindow>
  </div>
</template>
<script>
import { getOrderData } from "@api/order";
import {formatDate} from "@api/date.js";
import Loading from "@components/Loading";
import { mapGetters } from "vuex";
import { isWeixin } from "@utils";
import GeneralWindow from "@components/GeneralWindow";

const NAME = "MyOrder";

export default {
  name: NAME,
  data() {
    return {
      offlinePayStatus: 2,
      orderData: {},
      type: parseInt(this.$route.params.type) || 0,
      page: 1,
      limit: 20,
      loaded: false,
      loading: false,
      orderList: [],
      pay: false,
      payType: ["yue", "weixin"],
      from: isWeixin() ? "weixin" : "weixinh5",
      generalActive: false,
      generalContent: {
        promoterNum: "",
        title: ""
      }
    };
  },
  components: {
    Loading,
    GeneralWindow
  },
  computed: mapGetters(["userInfo"]),
  methods: {
    setOfflinePayStatus: function(status) {
      var that = this;
      that.offlinePayStatus = status;
      if (status === 1) {
        if (that.payType.indexOf("offline") < 0) {
          that.payType.push("offline");
        }
      }
    },
    getOrderData() {
      // console.log(this.userInfo.uid)
      var param={
        uid:this.userInfo.uid
      }
      getOrderData(param).then(res => {
        this.orderList = res;
      });
    }
  },
  filters: {
    formatDateDay(time) {
      var date = new Date(time);
      return formatDate(date, "yyyy-MM-dd");
    }
  },
  mounted() {
    this.getOrderData();
  }
};
</script>

<style scoped>
.noCart {
  margin-top: 0.17rem;
  padding-top: 0.1rem;
}

.noCart .pictrue {
  width: 4rem;
  height: 3rem;
  margin: 0.7rem auto 0.5rem auto;
}

.noCart .pictrue img {
  width: 100%;
  height: 100%;
}

.my-order-header{
  background-color: #2a7efb;
}
</style>
